module.exports = "/_next/static/images/b8a35e2a0e6eb14ca063452b70907c4d-cuenta-cards-xs.png.webp";